import React from 'react';
import { TrendingDown } from 'lucide-react';

export default function TierTable({ tiers, basePrice, activeTier, className = '' }) {
  if (!tiers?.length) return null;

  const sorted = [...tiers].sort((a, b) => a.min_qty - b.min_qty);

  return (
    <div className={className}>
      <div className="flex items-center gap-2 mb-3">
        <TrendingDown className="w-4 h-4 text-secondary" />
        <h4 className="text-sm font-semibold text-white font-heading">Paliers de prix</h4>
      </div>
      <div className="space-y-1.5">
        {sorted.map((tier) => {
          const isActive = activeTier && activeTier.min_qty === tier.min_qty;
          const saving = basePrice - tier.price;
          return (
            <div
              key={tier.min_qty}
              className={`flex items-center justify-between px-3 py-2 rounded-sm border transition-colors ${
                isActive
                  ? 'bg-secondary/10 border-secondary/40 text-white'
                  : 'bg-white/[0.02] border-slate-200 text-slate-600'
              }`}
            >
              <span className="text-sm">
                A partir de <span className="font-semibold text-white">{tier.min_qty}</span> unites
              </span>
              <div className="flex items-center gap-2">
                <span className={`font-bold font-heading ${isActive ? 'text-secondary' : 'text-slate-700'}`}>
                  {tier.price.toFixed(2)} €
                </span>
                {saving > 0 && (
                  <span className="text-[10px] text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded-full">
                    -{saving.toFixed(0)}€
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
